import React from "react";
import { SvgIconProps } from "./SvgIconProps";

const SubscribeIcon: React.FC<SvgIconProps> = ({ color, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 21" fillRule="evenodd" strokeLinecap="square" strokeLinejoin="round" strokeMiterlimit="3" {...props}>
        <path d="M10.726.606l2.998 6.516 7.131.836-5.266 4.872 1.403 7.035-6.266-3.508-6.256 3.508 1.403-7.035L.597 7.958l7.131-.836L10.726.606z" stroke={color || "currentColor"} strokeWidth="1.2" fill="none" />
    </svg>
);

export default SubscribeIcon;